module.exports = __webpack_public_path__ + "deniz.jpg?c886b9059660fcfd578e45aac3dba170";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/customers/deniz.jpg
// module id = 90
// module chunks = 0